import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'AGGIUNGI ESERCIZI',
        description:
            "Dopo aver aggiunto altri esercizi, premi 'Aggiungi esercizi' per tornare alla tua verifica. Premi 'Annulla' per annullare le modifiche e tornare alla tua verifica.",
        isActive: true,
        name: 'AddExerciseModalAnchor',
        tutorialName: 'aggiunta-esercizi_pulsantiera'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top'
    }
};
